import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "14 2 14 8 20 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M11.5 13.5c.32.4.5.94.5 1.5s-.18 1.1-.5 1.5",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M15 12c.64.8 1 1.87 1 3s-.36 2.2-1 3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 15h.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileVolume2";
const FileVolume2 = memo(themed(Icon));
export {
  FileVolume2
};
//# sourceMappingURL=file-volume-2.js.map
